import {
  Box,
  Stepper as ChakraStepper,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepperProps,
  Text,
} from '@chakra-ui/react'

export interface Props extends Omit<StepperProps, 'children' | 'onChange'> {
  steps: StepperStep[]
  onChange?: (index: number) => void
}

export interface StepperStep {
  title: string
  description?: string
  canClick?: boolean
}

export default function Stepper({ onChange, steps, ...rest }: Props) {
  return (
    <ChakraStepper colorScheme="primary" {...rest}>
      {steps.map(({ title, description, canClick }, index) => (
        <Step
          key={index}
          onClick={canClick ? () => onChange?.(index) : undefined}
          style={{ cursor: canClick ? 'pointer' : 'default' }}
        >
          <StepIndicator>
            <StepStatus
              complete={<StepIcon />}
              incomplete={<StepNumber />}
              active={<StepNumber />}
            />
          </StepIndicator>

          <Box>
            <Text color={canClick ? 'black' : 'gray.500'} textStyle="bodyMedium">
              {title}
            </Text>
            {description && (
              <Text mt={1} textStyle="bodySmall" color={canClick ? 'gray.500' : 'gray.300'}>
                {description}
              </Text>
            )}
          </Box>

          <StepSeparator />
        </Step>
      ))}
    </ChakraStepper>
  )
}
